import React, { Component } from 'react';

//componentes
import NotaCredito from './notaCredito'

class Index extends Component {

    render(){
        return(
            <div>
                <NotaCredito />
            </div>
        );
    }

}
export default Index;